import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { ResetEntryRedirectComponent } from './pages/reset-entry-redirect/reset-entry-redirect.component';
// import { DeliverySelectComponent } from './screen-steps/delivery-select/delivery-select.component';
// import { IspQuestionScreenComponent } from './screen-steps/isp-question-screen/isp-question-screen.component';

// import { MessageScreenComponent } from './screen-steps/message-screen/message-screen.component';
// import { TestPageComponent } from './screen-steps/test-page/test-page.component';
// import { PersonalDetailsComponent } from './screen-steps/personal-details/personal-details.component';
// import { ChooseDeviceComponent } from './screen-steps/choose-device/choose-device.component';
// import { InstallationAddressComponent } from './screen-steps/installation-address/installation-address.component';
// import { PaymentDetailsComponent } from './screen-steps/payment-details/payment-details.component';
// import { InstallationTimeComponent } from './screen-steps/installation-time/installation-time.component';
// import { BundleSalesLayoutComponent } from './layouts/bundle-sales-layout/bundle-sales-layout.component';

/***********************new******************************************* */
import { CallParentComponent } from './pages/call-parent/call-parent.component';
import { getEntryStartRoute, resolveEntryFromUrl } from './shared/utils/entry-url.util';

const generalEntryScreen = getEntryStartRoute(resolveEntryFromUrl(window.location.href));

const routes: Routes = [
  { path: 'paymentSuccess', component: PaymentSuccessComponent, pathMatch: 'full' },
  { path: 'paymentFailed', component: PaymentSuccessComponent, pathMatch: 'full' }, // TOdo change component
  // { // TODO: move 'test' to separate routing module or delete it
  //   path: 'test',
  //   component: BundleSalesLayoutComponent,
  //   children: [
  //     { path: 'personalDetails', component: PersonalDetailsComponent },
  //     { path: 'chooseDevice', component: ChooseDeviceComponent },
  //     { path: 'installationAddress', component: InstallationAddressComponent },
  //     { path: 'payment', component: PaymentDetailsComponent },
  //     { path: 'installationTime', component: InstallationTimeComponent },
  //     { path: 'ispQuestion', component: IspQuestionScreenComponent },
  //     { path: 'deliverySelect', component: DeliverySelectComponent },
  //     { path: 'messageScreen', component: MessageScreenComponent },
  //     { path: 'testPage', component: TestPageComponent }
  //   ]
  // },
  {
    path: 'PurchasingProcess',
    loadChildren: () =>
      import('./pages/purchasing-process/purchasing-process.module').then(m => m.PurchasingProcessModule)
  },
  {
    path: 'PurchasingProcessElectricity',
    loadChildren: () =>
      import('./pages/purchasing-process-electricity/purchasing-process-electricity.module').then(m => m.PurchasingProcessElectricityModule)
  },
  {
    path: 'SellerElectricity',
    loadChildren: () =>
      import('./pages/seller-electricity/seller-electricity.module').then(m => m.SellerElectricityModule)
  },
  { path: 'catch', component: CallParentComponent },
  { path: 'reset', component: ResetEntryRedirectComponent },
  //  { path: '**', redirectTo: 'PurchasingProcess/PersonalInformation' }
  { path: '**', redirectTo: generalEntryScreen }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
